import { useEffect, useState } from 'react'
import { empty } from 'utils/empty'

export function useQueryParams({ initialQueryParams = {}, tableFields } = {}) {
    const [queryParams, setQueryParams] = useState(initialQueryParams)
    const [sorting, setSorting] = useState([])
    const [columnFilters, setColumnFilters] = useState(
        initialQueryParams.filter
            ? Object.entries(initialQueryParams.filter)
                  .filter(([id, value]) => empty(value) && (tableFields?.includes(id) ?? true))
                  .map(([id, value]) => ({ id, value }))
            : [],
    )

    useEffect(() => {
        handleFiltersChange({
            ...tableFields?.reduce((carry, field) => ({ ...carry, [field]: '' }), {}),
            ...columnFilters.reduce((carry, el) => ({ ...carry, [el.id]: el.value }), {}),
        })
    }, [columnFilters])
    useEffect(() => {
        handleMultipleSortChange(sorting)
    }, [sorting])

    const handleFiltersChange = (values) => {
        setQueryParams((prev) => ({
            ...prev,
            filter: {
                ...prev.filter,
                ...values,
            },
        }))
    }
    const handleSortChange = (sort) => {
        setQueryParams((prev) => {
            const next = { ...prev }
            if (sort) {
                next.sort = `${sort.desc ? '-' : ''}${sort.id}`
            } else {
                delete next.sort
            }
            return next
        })
    }
    const handleMultipleSortChange = (sort) => {
        setQueryParams((prev) => {
            const next = { ...prev }
            if (sort.length) {
                next.sort = sort.map((s) => `${s.desc ? '-' : ''}${s.id}`).join(',')
            } else {
                delete next.sort
            }
            return next
        })
    }

    const handlePageChange = (page) => setQueryParams((prev) => ({ ...prev, page }))
    const handlePageSizeChange = (pageSize) => setQueryParams((prev) => ({ ...prev, pageSize }))

    const resetQueryParams = () => {
        setQueryParams({ ...initialQueryParams })
        setColumnFilters(
            initialQueryParams.filter
                ? Object.entries(initialQueryParams.filter)
                      .filter(([id, value]) => empty(value) && (tableFields?.includes(id) ?? true))
                      .map(([id, value]) => ({ id, value }))
                : [],
        )
        setSorting([])
    }
    const clearQueryParams = () => {
        setQueryParams({})
        setSorting([])
        setColumnFilters([])
    }
    const reloadQueryParams = () => setQueryParams((prev) => ({ ...prev }))

    return {
        queryParams,
        setQueryParams,
        sorting,
        setSorting,
        columnFilters,
        setColumnFilters,

        handleFiltersChange,
        handleSortChange,
        handleMultipleSortChange,

        handlePageChange,
        handlePageSizeChange,

        resetQueryParams,
        clearQueryParams,
        reloadQueryParams,
    }
}
